export default function objectSerialize(object: Record<string, any>) {
  const formData = new FormData();

  for (const key in object) {
    formData.append(key, object[key]);
  }
  return formData;
}
